import { render } from "./addDataWidget.htm?vue&type=template&id=5bf8829d&scoped=true&ts=true"
import script from "./addDataWidget.vue?vue&type=script&lang=ts"
export * from "./addDataWidget.vue?vue&type=script&lang=ts"

import "./addDataWidget.scss?vue&type=style&index=0&id=5bf8829d&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf8829d"]])

export default __exports__